'use strict';

class PromoFreeRoamingEurope {
	constructor(props = {}) {
		console.log('PromoFreeRoamingEurope::constructor(%o)', props);
		let _that = this;

		_that.destinationsEl = document.getElementById('destinations');
		_that.destinationsListEl = document.getElementById('destinations-countries-list');
		_that.expandToggleBtn = document.getElementById('destinations-countries-expand-toggle');

		_that = Object.assign(this, props);

		_that.pageEvents();
	}

	pageEvents() {
		const _that = this;

		window.addEventListener('hashchange', () => {
			_that.syncExpandedListWithHash();
		});

		window.addEventListener('resize', () => {
			_that.measureDestinationsList();
		});

		_that.measureDestinationsList();
		_that.toggleExpandDestinationsList();
		_that.syncExpandedListWithHash();
	}

	measureDestinationsList() {
		const height = this.destinationsListEl.scrollHeight.toString();
		this.destinationsListEl.setAttribute('data-height', height);
	}

	toggleExpandDestinationsList() {
		const _that = this;

		_that.expandToggleBtn.addEventListener('click', (e) => {
			e.preventDefault();
			_that.destinationsEl.classList.toggle('expended-list');
		});
	}

	syncExpandedListWithHash () {
		if (!this.destinationsEl) return;

		const hash = window.location.hash.slice(1);

		if (hash === 'destinations') {
			this.destinationsEl.classList.add('expended-list');
			scrollToAnchor(this.destinationsEl);
		} else {
			this.destinationsEl.classList.remove('expended-list');
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	try {
		new PromoFreeRoamingEurope();
	} catch (error) {
		console.warn(error);
	}
});
